// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import */
 
 
 
 
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import TransferBalanceForm from './transferBalanceForm';
const TransferBalance: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasTransferBalanceAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'TransferBalance')
  );

  return (
    <CardContainer>
      <Switch>
        <Route exact path={`${baseURL}`}>
          {hasTransferBalanceAddAccess ? <TransferBalanceForm /> : <NotAuthorized />}
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { TransferBalance };
